import styled from 'styled-components';
import { StyledPopUpBlock, StyledPopUpContainer } from '../styled';
import { StyledButton } from '../../../globalStyled';

export const StyledPopupHeader = styled.div`
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  z-index: 1;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const StyledPopUpBlockNoPadding = styled(StyledPopUpBlock)`
  padding: 0;
  max-width: 320px;
  max-height: 90vh;
  border-radius: ${({ theme }) => theme.cardRadius};
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid ${({ theme }) => theme.border};
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
`;
export const StyledParagraph = styled.p`
  margin-top: 20px;
  font-family: 'Archivo';
  font-size: 15px;
  line-height: 26px;
  padding: 30px;
  text-align: center;
`;

export const StyledButtonContainer = styled.div`
  width: 100%;
  padding: 0 20px;
`;

export const StyledPopupButton = styled(StyledButton)`
  width: 100%;
`;

export const StyledStaticPopUpContainer = styled(StyledPopUpContainer)`
  min-height: min(680px, 70vh);
  @media only screen and (max-width: 991px) {
    min-height: min(440px, 70vh);
  }
`;

export const StyleLoaderContainer = styled.div`
  min-height: min(680px, 70vh);
  @media only screen and (max-width: 991px) {
    min-height: min(440px, 70vh);
  }
  display: flex;
  justify-content: center;
  align-items: center;
`;
